<template>
  <v-dialog
  persistent
  v-model="showDialog"
  max-width="400px"
  :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <span class="edit-button" slot="activator">edit</span>
    <v-card :class="{'no-border': $vuetify.breakpoint.xsOnly}">
      <v-form v-model="valid">
      <v-container class="modal-pad">
        <v-layout row align-center wrap mb-3>
          <v-flex xs10 style="height:30px;">
            <span class="subheading">Edit quote details</span>
          </v-flex>
          <v-flex xs2 class="text-xs-right">
            <span class="done-button" @click="onSaveChanges" v-if='valid'>done</span>
            <span class="done-button disabled" v-if='!valid'>done</span>
          </v-flex>
        </v-layout>
        <v-layout row v-if="invoice.status === 'Quote sent'">
          <v-flex xs12>
            <v-alert color="warning" icon="info" value="true">
              This quote has been Sent.
            </v-alert>
          </v-flex>
        </v-layout>
        <v-layout column pt-2>
          <v-flex xs12>
            <v-text-field
            v-if="autoIncrement"
            name="quote_ref_display_only"
            label="Quote number (automatic)"
            id="quote_ref_display_only"
            :value="displayedQuoteNumber"
            type="text"
            autofocus
            ref="focus"
            placeholder=" "
            disabled
            ></v-text-field>
            <v-text-field
            v-else
            name="quote_ref"
            label="Quote number (required)"
            id="quote_ref"
            v-model="addedquote_ref"
            type="text"
            autofocus
            ref="focus"
            placeholder=" "
            required
            :rules="[input_required]"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
          <v-menu
            lazy
            ref="menu_quoted_date_ref"
            :close-on-content-click="false"
            v-model="menu_quoted_date"
            transition="scale-transition"
            :return-value.sync="addedquoted_date"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            >
              <v-text-field
              slot="activator"
              label="Quoted date"
              v-model="addedquotedDateFormatted"
              readonly
              placeholder=" "
              append-icon="date_range"
              clearable
            ></v-text-field>
            <v-date-picker v-model="addedquoted_date" @input="$refs.menu_quoted_date_ref.save(addedquoted_date); addedquotedDateFormatted = formatDate($event)"
            no-title
            >
            </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12>
          <v-menu
            lazy
            ref="menu_validto_date_ref"
            :close-on-content-click="false"
            v-model="menu_validto_date"
            transition="scale-transition"
            :return-value.sync="addedvalidto_date"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            >
              <v-text-field
              slot="activator"
              label="Valid to date"
              v-model="addedvalidtoDateFormatted"
              readonly
              placeholder=" "
              append-icon="date_range"
              clearable
            ></v-text-field>
            <v-date-picker v-model="addedvalidto_date" @input="$refs.menu_validto_date_ref.save(addedvalidto_date); addedvalidtoDateFormatted = formatDate($event)"
            no-title
            >
            </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12>
            <v-textarea
              name="notes"
              label="Add a note to your quote"
              id="invoicenote"
              v-model="addedNote"
              clearable
              placeholder=" "
              rows="2"
              hint="Use enter key to add line breaks"
              required></v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatDate } from '@/components/Mixins/formatDate'

export default {
  name: 'EditQuoteDetailsModal',
  props: {
    invoice: Object,
    quotedDateFormatted: String,
    validtoDateFormatted: String,
    autoIncrement: Boolean,
    displayedQuoteNumber: String
  },
  mixins: [formatDate],
  data () {
    return {
      valid: false,
      showDialog: false,
      menu_quoted_date: false,
      menu_validto_date: false,
      addedquote_ref: this.invoice.quote_ref,
      addedNote: this.invoice.note,
      addedquoted_date: this.invoice.quoted_date,
      addedvalidto_date: this.invoice.validto_date,
      addedquotedDateFormatted: this.quotedDateFormatted,
      addedvalidtoDateFormatted: this.validtoDateFormatted,
      input_required: value => !!value || 'Required.'
    }
  },
  watch: {
    showDialog (val) {
      if (!val) return
      requestAnimationFrame(() => {
        this.$refs.focus.focus()
      })
    }
  },
  methods: {
    saveDate (date, dateField) {
      this['menu_' + dateField] = false
    },
    cancelDate (dateField) {
      this['menu_' + dateField] = false
    },
    clearDate (dateField) {
      // pass the job.date object then set it to zilch. clear the job.chasedate
      this.invoice[dateField] = ''
      this[dateField + 'Formatted'] = ''
      this['menu_' + dateField] = false
    },
    toggleDialog () {
      this.showDialog = !this.showDialog
    },
    onSaveChanges () {
      if (this.addedquotedDateFormatted == null) {
        this.addedquoted_date = null
      }
      if (this.addedvalidtoDateFormatted == null) {
        this.addedvalidto_date = null
      }
      this.$emit('return-invoice-details', {
        quote_ref: this.addedquote_ref,
        quoted_date: this.addedquoted_date,
        validto_date: this.addedvalidto_date,
        note: this.addedNote,
        quotedDateFormatted: this.addedquotedDateFormatted,
        validtoDateFormatted: this.addedvalidtoDateFormatted
      })
      this.showDialog = false
    }
  }

}
</script>
